<table *ngIf="stats && stats.length > 0" mat-table [dataSource]="stats" class="mat-elevation-z2 full-width grade-table">

  <!-- Excellent Column -->
  <ng-container matColumnDef="excellent">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span class="color-green">{{localizeExamGrade(examGrades.excellent)}}</span>
    </th>
    <td mat-cell *matCellDef="let element" class="excellent center-align mat-body-2">
      {{element.excellent_count || 0}}
    </td>
  </ng-container>

  <!-- Good Column -->
  <ng-container matColumnDef="good">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span class="color-orange">{{localizeExamGrade(examGrades.good)}}</span>
    </th>
    <td mat-cell *matCellDef="let element" class="good center-align mat-body-2">
      {{element.good_count || 0}}
    </td>
  </ng-container>

  <!-- Average Column -->
  <ng-container matColumnDef="average">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span class="color-yellow">{{localizeExamGrade(examGrades.average)}}</span>
    </th>
    <td mat-cell *matCellDef="let element" class="average center-align mat-body-2">
      {{element.average_count || 0}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay;"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
</table>
